import settings from '@api/routes/raa-api/get-reqappt-flow-settings';
import confirmRequest from '@api/routes/raa-api/confirm-book-appointment';
import * as templates from './templates';
import * as createEl from './raa-create-elements';

var VCA = VCA || {};


VCA.requestAppointmentForm = (function ($) {

    var ui = {};

    var requestInfo = {
        'hospitalIDValue': '',
        'hospitalName': '',
        'hospitalType': '',
        'isVersion2': '',
        'isLoggedIn': '',
        'isExistClient': 'null',
        'isPrimaryHospital': '',
        'petName': 'pet',
        'resourceId': '',
        'resouceName': '',
        'preferredDate1': '',
        'preferredDate2': '',
        'preferredDate3': '',
        'preferredDateDisplay1': '',
        'preferredDateDisplay2': '',
        'preferredDateDisplay3': '',
        'preferredTime1': '',
        'preferredTime2': '',
        'preferredTime3': '',
        'preferredTimeDisplay1': '',
        'preferredTimeDisplay2': '',
        'preferredTimeDisplay3': '',
        'clientType': '',
        'conditionMessage': '',
        'settingsIdValue': '',
        'firstName': '',
        'lastName': '',
        'email': '',
        'phone': '',
        'utm_campaign': '',
        'utm_content': '',
        'utm_medium': '',
        'utm_source': '',
        'utm_term': '',
        'gclid': ''
    }




    function cacheUI() {
        ui.$reqApptReason = $('section[data-step="req-appt-reason"]');
        ui.$errorStep = $('section[data-step="error"]');
        ui.$selectDoc = $('section[data-step="select-doc"]');
        ui.$apptDateTime = $('section[data-step="appt-date-selector"]');
        ui.$apptDetails = $('section[data-step="appt-details"]');
        ui.$bookConfirm = $('section[data-step="book-confirm"]');
        ui.$progressBar = $('div[data-progress="bar"]');
        ui.$sections = $('.js-seciton-step');
        ui.$backBtn = $('button[data-btn="back"]');
        ui.$abandonLink = $('.js-abandon-link');
        ui.loader = $('.js-loader');
    }

    function init() {
        if ($('.req-appt__wrapper').length <= 0) {
            return;
        }

        cacheUI();
        initRAAForm();

        bindSelectDocClick();
        bindDocContinueClick();
        bindMessageContinueClick();
        bindCheckDateClick();
        bindBackBtnClick();
        bindClientInfoFormClick();

        // on change
        bindfieldUpdate();
        showLoader();

        abandonDataLayerPush();
    }


    async function initRAAForm() {

        requestInfo.hospitalIDValue = ui.$reqApptReason.attr('data-attr-hospId');
        requestInfo.settingsIdValue = ui.$reqApptReason.attr('data-attr-dsid');
        requestInfo.hospitalType = ui.$reqApptReason.attr('data-attr-hospType');
        requestInfo.hospitalName = ui.$reqApptReason.attr('data-attr-hospName');

        var params = {
            hospitalId: requestInfo.hospitalIDValue,
            settingsId: requestInfo.settingsIdValue
        };

        if(window.location.href.match(/\?./)){
            const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));

            for(const [ key, value ] of urlParams.entries()){
                requestInfo[key] = value;

                if(key == 'returnUrl'){
                    ui.$abandonLink.attr("href", value);
                }
            }
        }

        const {
            success,
            data,
            error
        } = await settings.query(params);
        if (!success) {
            console.log('failed', error);
            let targetValue = 'error';
            $('.js-error-message').text(error);
            updateSeciton(targetValue);
            return;
        }
        let response = data

        let docResource = response.ResourceList;
        let dayTimeRange = response.DayTimeRangeOptions;
        let clientInfo = response.Client;
        requestInfo.isLoggedIn = response.IsLoggedIn;

        //console.log(response);

        let selectDocBody = ui.$selectDoc.find(".js-req-appt-doc-list");
        if (response.IsLoggedIn) {
            populateClinetForm(clientInfo);
        }
        createEl.createDocBtns(docResource, selectDocBody);

        //createPetTypeBtns(petTypes);
        let dayTimeSelector = ui.$apptDateTime.find(".select-box select");
        createEl.createDayTimeOptions(dayTimeRange, dayTimeSelector);

        ui.$sections.hide();
        ui.$reqApptReason.show();
        ui.$progressBar.show();
        updateProgresBar('req-appt-reason');

        setTimeout(function () {
            $('#prefDate-1').flatpickr({
                minDate: "today",
                altInput: true,
                altFormat: "l, M j, Y",
                dateFormat: "Y-m-d",
                disableMobile: true
            });
            $('#prefDate-2').flatpickr({
                minDate: "today",
                altInput: true,
                altFormat: "l, M j, Y",
                dateFormat: "Y-m-d",
                disableMobile: true
            });
            $('#prefDate-3').flatpickr({
                minDate: "today",
                altInput: true,
                altFormat: "l, M j, Y",
                dateFormat: "Y-m-d",
                disableMobile: true
            });
        }, 100);

        setTimeout(function () {
            $('.flatpickr-prev-month').attr('role', 'button').attr('tabindex', '0');
            $('.flatpickr-next-month').attr('role', 'button').attr('tabindex', '0');
            $('.flatpickr-day.today').attr('tabindex', '0');
            //  console.log('make calendar ADA');
        }, 1000);

        hideLoader();

        window.VCA.raaDatalayer.datalayerPushPageLoad(requestInfo);

    };

    function updateSeciton(targetValue) {
        ui.$sections.hide();
        $('section[data-step="' + targetValue + '"').show();
        hideLoader();
        updateProgresBar(targetValue);
    }

    function updateProgresBar(targetValue) {
        var progressValue = $('section[data-step="' + targetValue + '"').attr('data-progress');
        if (targetValue === "entry") {
            ui.$progressBar.hide();
        }
        if (targetValue === "select-pet" || targetValue === "select-exist-pet") {
            ui.$progressBar.show();
        }
        $('.progress-bar').css('width', progressValue + '%').attr('aria-valuenow', progressValue);
    }

    function bindBackBtnClick() {
        ui.$backBtn.on('click', function (e) {
            e.preventDefault();
            var targetValue = $(this).attr('data-target');
            updateSeciton(targetValue);
        });
    }

    function bindCheckDateClick() {
        $('.js-seciton-step').on('click', '.js-select-appt-continue', function (e) {
            e.preventDefault();

            if (!checkApptTimes()) {
                return;
            }
            var targetValue = $(this).attr('data-target');
            buildrequestDetialsPage(targetValue);

            window.VCA.raaDatalayer.datalayerPushStepChange(requestInfo, targetValue,'appt-date-selector' );
        });
    }

    async function sendBookConfirmation(targetValue) {

        var params = {
            hospitalId: requestInfo.hospitalIDValue,
            clientType: requestInfo.clientType,
            resourceId: requestInfo.resourceId,
            resourceName: requestInfo.resouceName,
            isExisting: requestInfo.isExistClient,
            IsV2: requestInfo.isVersion2,
            firstName: requestInfo.firstName,
            lastName: requestInfo.lastName,
            petName: requestInfo.petName,
            email: requestInfo.email,
            phone: requestInfo.phone,
            conditionMessage: requestInfo.conditionMessage,
            isPrimaryHospital: requestInfo.isPrimaryHospital,
            preferredDate1: requestInfo.preferredDate1,
            preferredDate2: requestInfo.preferredDate2,
            preferredDate3: requestInfo.preferredDate3,
            preferredTime1: requestInfo.preferredTime1,
            preferredTime2: requestInfo.preferredTime2,
            preferredTime3: requestInfo.preferredTime3,
            ReferrerUrl: document.referrer,
            TrackingUrl: window.location.href,
            TrackingMedium: requestInfo.utmMedium,
            TrackingSource: requestInfo.utmSource,
            TrackingCampaign: requestInfo.utmCampaign,
            TrackingTerm: requestInfo.utmTerm,
            TrackingContent: requestInfo.utmContent,
            GClid: requestInfo.gclid
        };

        //console.log(params);

        const {
            success,
            data,
            error
        } = await confirmRequest.query(params);
           //console.log(data);
        if (!success || !data) {
            console.log('failed', error);
            let targetValue = 'error';
            $('.js-error-message').text(error);
            updateSeciton(targetValue);
            return;
        } else {
            createConfirmStepInfo(targetValue);
            window.VCA.raaDatalayer.datalayerPushPostSubmit(requestInfo);
        }
    }

    function createConfirmStepInfo(targetValue) {
        $('.js-pet-name').text(requestInfo.petName);
        updateSeciton(targetValue);
    }

    function buildrequestDetialsPage(targetValue) {
        $('.js-req-date-1').text(requestInfo.preferredDateDisplay1);
        $('.js-req-time-1').text(requestInfo.preferredTimeDisplay1);
        $('.js-req-date-2').text(requestInfo.preferredDateDisplay2);
        $('.js-req-time-2').text(requestInfo.preferredTimeDisplay2);
        $('.js-req-date-3').text(requestInfo.preferredDateDisplay3);
        $('.js-req-time-3').text(requestInfo.preferredTimeDisplay3);
        $('.js-selected-doc').text(requestInfo.resouceName);
        $('.js-confirmation-comment').text(requestInfo.conditionMessage);
        //  console.log(data);
        //console.log(requestInfo);
        updateSeciton(targetValue);
    }

    function checkApptTimes() {

        let valid = true


        $('.js-day-time-fields .flatpickr-input').each(function (index) {
            let el = $(this);
            let elTime = el.closest('.form-label-group').find('.select-box__select');
            let elTimeWrapper = el.closest('.form-label-group').find('.select-box');
            let elmId = el.attr("id");
            index = index + 1;

            if (elmId == 'prefDate-1') {
                if (el.val() == '') {
                    el.addClass('error');
                    el.closest('.date-wrapper').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.date-wrapper').removeClass('error');
                    let pkey = 'preferredDate' + index;
                    let dkey = 'preferredDateDisplay' + index;
                    requestInfo[pkey] = el.val();
                    requestInfo[dkey] = el.next('input').val();
                }
            } else {
                if (el.val() != '' && elTime.val() == null) {
                    elTimeWrapper.addClass('error');
                    valid = false;
                } else {
                    elTimeWrapper.removeClass('error');
                    let pkey = 'preferredDate' + index;
                    let dkey = 'preferredDateDisplay' + index;
                    requestInfo[pkey] = el.val();
                    requestInfo[dkey] = el.next('input').val();
                }
            }
        });

        $('.js-day-time-fields .select-box__select').each(function (index) {
            let el = $(this);
            let elDay = el.closest('.form-label-group').find('.flatpickr');
            let elDateWrapper = el.closest('.form-label-group').find('.date-wrapper');
            let elmId = el.attr("id");
            index = index + 1;

            if (elmId == 'preferred-time-1') {
                if (el.val() == '' || el.val() == null) {
                    el.addClass('error');
                    el.closest('.select-box').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.select-box').removeClass('error');
                    let pkeyv = 'preferredTime' + index;
                    let pkey = 'preferredTimeDisplay' + index;
                    requestInfo[pkeyv] = el.val();
                    requestInfo[pkey] = el.find(':selected').data('name');
                }
            } else {
                if (el.val() != null && elDay.val() == '') {
                    elDateWrapper.addClass('error');
                    valid = false;
                } else {
                    elDateWrapper.removeClass('error');
                    let pkeyv = 'preferredTime' + index;
                    let pkey = 'preferredTimeDisplay' + index;
                    requestInfo[pkeyv] = el.val();
                    requestInfo[pkey] = el.find(':selected').data('name');
                }
            }
        });


        return valid;
    }


    function checkChform() {
        var mailFormat = /(^[a-zA-Z0-9_.]+[@]{1}[a-zA-Z0-9\-]+[\.][a-zA-Z]+$)/;
        var phoneReg = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        var textReg = /^[a-zA-Z -]{2,60}$/;

        let valid = true

        $('.js-client-form input.js-required').each(function (index) {
            let el = $(this);
            let elmId = el.attr("id");
            if (elmId == 'phone') {
                let phone = $('#phone').val();
                if (!phoneReg.test(phone)) {
                    $('#phone').addClass('error');
                    $('#phone').closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    $('#phone').removeClass('error');
                    $('#phone').closest('.form-label-group').removeClass('error');
                    requestInfo.phone = $('#phone').val();
                }
            } else if (elmId == 'email') {
                let email = $('#email').val();
                if (!mailFormat.test(email)) {
                    $('#email').addClass('error');
                    $('#email').closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    $('#email').removeClass('error');
                    $('#email').closest('.form-label-group').removeClass('error');
                    requestInfo.email = $('#email').val();
                }
            } else {
                if (!textReg.test(el.val())) {
                    el.addClass('error');
                    el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.form-label-group').removeClass('error');
                    requestInfo[elmId] = el.val();
                }
            }
        });
        $('.js-client-form .select-box__select').each(function (index) {
            let el = $(this);
            let elmId = el.attr("id");

            if (el.val() == '' || el.val() == null) {
                el.addClass('error');
                el.closest('.form-label-group').addClass('error');
                valid = false;
            } else {
                el.removeClass('error');
                el.closest('.form-label-group').removeClass('error');
                requestInfo[elmId] = el.val();
            }

        });

        return valid;
    }

    function populateClinetForm(clientInfo) {
        let primaryEmail = '';
        $.each(clientInfo.ClientEmails, function (i, email) {
            if(email.IsPrimary) {
                primaryEmail =  email.Email;
            }
        });
        let primaryPhone = '';
        $.each(clientInfo.ClientPhones, function (i, phone) {
            if(phone.IsPrimaryContact) {
                primaryPhone =  phone.PhoneNumber;
            }
        });
        $('.js-client-form').find('#firstName').val(clientInfo.FirstName);
        $('.js-client-form').find('#lastName').val(clientInfo.LastName);
        $('.js-client-form').find('#email').val(primaryEmail);
        $('.js-client-form').find('#phone').val(primaryPhone);
    }

    function bindClientInfoFormClick() {
        $('.js-seciton-step').on('click', '.js-client-info-form', function (e) {
            e.preventDefault();

            if (!checkChform()) {
                return;
            }
            //console.log(requestInfo);
            showLoader();
            var targetValue = $(this).attr('data-target');
            sendBookConfirmation(targetValue);
            window.VCA.raaDatalayer.datalayerPushComfirm(requestInfo);
        });
    }

    function bindSelectDocClick() {
        $('.js-seciton-step').on('click', '.js-doc-select', function (e) {
            e.preventDefault();
            requestInfo.resourceId = $(this).attr('data-resouce-id');
            requestInfo.resouceName = $(this).attr('data-resouce-name');
            $('.js-req-appt-doc-list').find('.active').removeClass('active');
            $(this).addClass('active');
            var wrap = $(this).closest('.req-appt__form__body');
            wrap.find('.js-btn-required').removeClass('disabled');
        });
    }

    function bindMessageContinueClick() {
        $('.js-seciton-step').on('click', '.js-select-btn-condition', function (e) {
            e.preventDefault();
            var wrap = $(this).closest('.req-appt__form__body');
            if (wrap.find('.js-required').val() === '') {
                wrap.find('.js-required').trigger('focus');
                return;
            }
            var newMessage = wrap.find('.js-conditionmessage').val();
            requestInfo.conditionMessage = newMessage;
            var targetValue = $(this).attr('data-target');
            updateSeciton(targetValue);
            window.VCA.raaDatalayer.datalayerPushStepChange(requestInfo, targetValue, 'req-appt-reason');
        });
    }

    function bindDocContinueClick() {
        $('.js-seciton-step').on('click', '.js-doc-btn-condition', function (e) {
            e.preventDefault();
            if ($('.js-req-appt-doc-list .active').length < 1) {
                return;
            }
            var targetValue = $(this).attr('data-target');
            updateSeciton(targetValue);
            window.VCA.raaDatalayer.datalayerPushStepChange(requestInfo, targetValue, 'select-doc');
            //console.log(requestInfo);
        });
    }

    function bindfieldUpdate() {
        $('.js-conditionmessage').on('keyup', function (e) {
            e.preventDefault();
            var wrap = $(this).closest('.req-appt__form__body');
            var counter = wrap.find('.js-limit-counter');
            if ($(this).val() !== '') {
                wrap.find('.js-btn-required').removeClass('disabled');
            } else if ($(this).val() === '') {
                wrap.find('.js-btn-required').addClass('disabled');
            }

            if (this.value.length > 256) {
                return false;
            }
            counter.html(256 - this.value.length);
        });
    }

    function abandonDataLayerPush() {
        $('.js-seciton-step').on('click', '.js-abandon-link', function (e) {
            let backStepValue = $(this).closest('section[data-step]').attr('data-step');
            window.VCA.raaDatalayer.datalayerPushAbandon(requestInfo, backStepValue);
        });
    }

    function showLoader() {
        ui.$sections.css('opacity', '.3').css('pointer-events', 'none');
        ui.loader.show();
    }

    function hideLoader() {
        ui.$sections.css('opacity', '1').css('pointer-events', 'all');
        ui.loader.hide();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.requestAppointmentForm.init();
});